export const CONDITION_STEPS = [
  {
    key: "screen",
    title: "Screen & Display Condition",
    subtitle: "Check the front glass and display quality",
    options: [
      { value: "flawless", label: "Flawless / Like New", desc: "No scratches, display perfect", tag: "Best" },
      { value: "minor", label: "Minor Scratches", desc: "1-2 hairline scratches, touch works fine", tag: "-8%" },
      { value: "deep", label: "Deep Scratches / Dents", desc: "Visible dents on screen edges", tag: "-18%" },
      { value: "cracked", label: "Cracked Glass / Dead Pixels", desc: "Cracks, lines, or dead spots", tag: "-35%" },
    ],
  },
  {
    key: "body",
    title: "Body & Frame Condition",
    subtitle: "Inspect the back panel and side frame",
    options: [
      { value: "pristine", label: "Pristine", desc: "No chips, no dents", tag: "Best" },
      { value: "light", label: "Light Normal Wear", desc: "Micro-scratches from daily use", tag: "-5%" },
      { value: "heavy", label: "Heavy Dents / Bent Frame", desc: "Visible dents or frame bent", tag: "-20%" },
    ],
  },
  {
    key: "functional",
    title: "Hardware & Functional Check",
    subtitle: "Every button, port and sensor working?",
    options: [
      { value: "all_ok", label: "All Functional", desc: "FaceID, camera, mic, speaker — all OK", tag: "Best" },
      { value: "battery_low", label: "Battery Health < 80%", desc: "Service Battery notice", tag: "-10%" },
      { value: "port_speaker", label: "Charging Port / Speaker Issue", desc: "Slow charging, muffled speaker", tag: "-15%" },
      { value: "camera_id", label: "Camera / FaceID / TouchID Issue", desc: "Any biometric or camera fault", tag: "-25%" },
    ],
  },
  {
    key: "accessories",
    title: "Box, Charger & Bill",
    subtitle: "What comes along with the device?",
    options: [
      { value: "full_kit", label: "Original Box + Charger + GST Bill", desc: "Full retail kit + valid bill", tag: "+5%" },
      { value: "box_only", label: "Original Box Only", desc: "Box present, no original charger", tag: "-3%" },
      { value: "device_only", label: "Only Device", desc: "No box, no charger, no bill", tag: "-8%" },
    ],
  },
];

export const PICKUP_SLOTS = [
  { value: "morning", label: "Morning (10 AM – 1 PM)" },
  { value: "afternoon", label: "Afternoon (1 PM – 5 PM)" },
  { value: "evening", label: "Evening (5 PM – 9 PM)" },
];
